import { useCallback } from "react";

import { retrieveAuthKey } from "../../../utils/auth";

interface UseGetTariffPdfParams {
  invoiceId: number;
  tariffId: number;
  document: string;
}

export const useGetTariffPdf = ({
  invoiceId,
  tariffId,
  document
}: UseGetTariffPdfParams) => {
  const getTariffPdf = useCallback(async () => {
    try {
      const apiUrl = import.meta.env.VITE_API_URL;
      const authKey = retrieveAuthKey();

      if (!authKey) {
        throw new Error("Usuário não autenticado");
      }

      const url = `${apiUrl}/invoices/${invoiceId}/tariff-pdf/${tariffId}?document=${document}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Organization: "1",
          Authorization: `Bearer ${authKey.accessToken}`
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar PDF da tarifa: ${response.status}`);
      }

      const data = await response.arrayBuffer();
      return { data };
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error(String(error));
    }
  }, [invoiceId, tariffId, document]);

  return {
    getTariffPdf
  };
};
